/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetDataModel } from '../../models/patient-target-data-model';

export interface GetTargetRawData$Params {
  targetId?: number;
  startDate?: string;
  endDate?: string;
}

export function GetTargetRawData(http: HttpClient, rootUrl: string, params?: GetTargetRawData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientTargetDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetTargetRawData.PATH, 'get');
  if (params) {
    rb.query('targetId', params.targetId, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientTargetDataModel>>;
    })
  );
}

GetTargetRawData.PATH = '/api/Supervisor/GetTargetRawData';
